import { cleanTitle } from "components/Contentful/RichTextRenderer/RichTextRenderer.utils"
import React from "react"
import type { LivePromoTileContentBlock } from "types/cms"
import { createMarkup } from "utils/createMarkup"

import {
  container,
  contentVariant,
  colors,
  fontVariant,
} from "./ContentBlock.css"

type Props = LivePromoTileContentBlock

export const ContentBlock: React.FC<Props> = ({
  alignment,
  font,
  fontColour,
  fontSize,
  width,
  title,
  leftAlignment,
  topAlignment,
  letterSpacing,
  lineHeight,
  id,
}) => (
  <div
    data-testid={id}
    className={container}
    style={
      {
        left: leftAlignment ? `${leftAlignment + 50}%` : "50%",
        width: width ? `${width}%` : "100%",
        top: topAlignment ? `${topAlignment}%` : "25%",
        textAlign: alignment.toLowerCase() ?? "center",
      } as React.CSSProperties
    }
  >
    <h3
      id={cleanTitle(title)}
      className={`${contentVariant[font]} ${fontVariant[fontSize]} ${colors[fontColour]}`}
      style={
        {
          letterSpacing: letterSpacing ? `${letterSpacing}px` : undefined,
          lineHeight: lineHeight ? `${lineHeight}px` : undefined,
        } as React.CSSProperties
      }
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={createMarkup(title ?? "Enter a title")}
    />
  </div>
)
